import { ROLES, resolveUserRole } from '../constants/rolePermissions';

export const resolveCompanyConfigurations = source =>
  source?.data?.companyConfigurations ||
  source?.data?.company_configurations ||
  source?.data ||
  source?.company_configurations ||
  source?.companyConfigurations ||
  source ||
  {};

export const normalizeCompanyConfigurationsContainer = source => {
  const companyConfigurations = resolveCompanyConfigurations(source);

  if (
    !companyConfigurations ||
    typeof companyConfigurations !== 'object' ||
    Array.isArray(companyConfigurations)
  ) {
    return source || {};
  }

  return {
    ...(source || {}),
    companyConfigurations,
    company_configurations: companyConfigurations
  };
};

export const parseNumericInput = value => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : NaN;
  }

  if (typeof value !== 'string') {
    return NaN;
  }

  const normalized = value
    .trim()
    .replace(/\s+/g, '')
    .replace(/[^\d,.-]/g, '');

  if (!normalized) {
    return NaN;
  }

  const hasComma = normalized.includes(',');
  const hasDot = normalized.includes('.');

  const decimalNormalized =
    hasComma && !hasDot
      ? normalized.replace(',', '.')
      : normalized.replace(/,/g, '');

  return Number(decimalNormalized);
};

export const getAverageDeveloperCostFromSource = source => {
  const configurations = resolveCompanyConfigurations(source);
  const numericValue = parseNumericInput(
    configurations?.average_developer_cost_per_hour
  );

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return 0;
  }

  return numericValue;
};

export const hasAverageDeveloperCost = source =>
  getAverageDeveloperCostFromSource(source) > 0;

export const shouldFetchAverageDeveloperCostFromEndpoint = (...roles) => {
  const resolvedRole = resolveUserRole(...roles);

  return resolvedRole === ROLES.VIEWER || resolvedRole === ROLES.DEMO_USER;
};

export const getCertificationLogoFromSource = source => {
  const configurations = resolveCompanyConfigurations(source);
  const logo = configurations?.certification_logo;

  if (!logo || typeof logo !== 'object' || Array.isArray(logo)) {
    return null;
  }

  const dataUrl = String(logo.data_url || '').trim();
  const fileName = String(logo.file_name || '').trim();
  const mimeType = String(logo.mime_type || '').trim();

  if (!dataUrl || !fileName || !mimeType) {
    return null;
  }

  return {
    data_url: dataUrl,
    file_name: fileName,
    mime_type: mimeType
  };
};
